module.exports = __webpack_public_path__ + "img/title-shiba.fadeed16.png";